"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/** @jsx jsx */


var Logo = function Logo(_ref) {
  var icon = _ref.icon,
      width = _ref.width;
  var viewBoxWidth = icon ? '44' : '275';
  var StyledSvg = (0, _styled["default"])('svg')({});
  return (0, _themeUi.jsx)(StyledSvg, {
    sx: {
      width: width
    },
    viewBox: "0 0 " + viewBoxWidth + " 44",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, (0, _themeUi.jsx)("title", null, "four for business Logo - black"), (0, _themeUi.jsx)("defs", null, icon || (0, _themeUi.jsx)(_react["default"].Fragment, null, (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M59.2742,21.2948 L56.8472,21.2948 L56.8472,18.6508 L59.2742,18.6508 L59.2742,15.3558 C59.2742,12.3858 60.6862,10.2128 64.1272,10.2128 C65.0692,10.2128 65.7562,10.3568 66.0462,10.5388 L66.0462,13.3278 C65.7202,13.2198 65.1772,13.1098 64.7062,13.1098 C63.2212,13.1098 62.7512,14.0508 62.7512,15.6088 L62.7512,18.6508 L66.0462,18.6508 L66.0462,21.2948 L62.7512,21.2948 L62.7512,34.5508 L59.2742,34.5508 L59.2742,21.2948 Z",
    id: "path-1"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M66.1716,26.5824 C66.1716,20.1004 70.2286,18.2894 73.8136,18.2894 C77.3996,18.2894 81.4566,20.1004 81.4566,26.5824 C81.4566,33.0664 77.3996,34.9134 73.8136,34.9134 C70.2286,34.9134 66.1716,33.0664 66.1716,26.5824 Z M77.9426,26.5824 C77.9426,22.9614 76.5306,21.1864 73.8136,21.1864 C71.0976,21.1864 69.6856,22.9614 69.6856,26.5824 C69.6856,30.1684 71.0976,32.0154 73.8136,32.0154 C76.5306,32.0154 77.9426,30.1684 77.9426,26.5824 Z",
    id: "path-3"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M83.6355,18.6513 L87.1125,18.6513 L87.1125,27.7423 C87.1125,30.4593 87.6925,31.9063 90.1545,31.9063 C91.9295,31.9063 93.0155,31.1463 93.6685,30.4953 L93.6685,18.6513 L97.1455,18.6513 L97.1455,34.5503 L94.1745,34.5503 L94.1745,32.4853 C93.3055,33.7893 91.7125,34.9133 88.9955,34.9133 C86.3875,34.9133 83.6355,33.8273 83.6355,28.4303 L83.6355,18.6513 Z",
    id: "path-5"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M100.4817,18.6513 L103.4527,18.6513 L103.4527,20.7523 C104.2127,19.3033 105.4807,18.2893 107.7257,18.2893 C108.8117,18.2893 109.3917,18.5073 109.6087,18.6153 L109.6087,21.6583 C109.0657,21.4403 108.2687,21.2233 107.2907,21.2233 C105.5157,21.2233 104.4657,21.9463 103.9587,22.7083 L103.9587,34.5503 L100.4817,34.5503 L100.4817,18.6513 Z",
    id: "path-7"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M118.5827,21.2948 L116.1547,21.2948 L116.1547,18.6508 L118.5827,18.6508 L118.5827,15.3558 C118.5827,12.3858 119.9947,10.2128 123.4357,10.2128 C124.3777,10.2128 125.0647,10.3568 125.3547,10.5388 L125.3547,13.3278 C125.0297,13.2198 124.4857,13.1098 124.0147,13.1098 C122.5297,13.1098 122.0597,14.0508 122.0597,15.6088 L122.0597,18.6508 L125.3547,18.6508 L125.3547,21.2948 L122.0597,21.2948 L122.0597,34.5508 L118.5827,34.5508 L118.5827,21.2948 Z",
    id: "path-9"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M125.466,26.5824 C125.466,20.1004 129.523,18.2894 133.108,18.2894 C136.694,18.2894 140.749,20.1004 140.749,26.5824 C140.749,33.0664 136.694,34.9134 133.108,34.9134 C129.523,34.9134 125.466,33.0664 125.466,26.5824 Z M137.237,26.5824 C137.237,22.9614 135.825,21.1864 133.108,21.1864 C130.392,21.1864 128.98,22.9614 128.98,26.5824 C128.98,30.1684 130.392,32.0154 133.108,32.0154 C135.825,32.0154 137.237,30.1684 137.237,26.5824 Z",
    id: "path-11"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M143.0627,18.6513 L146.0327,18.6513 L146.0327,20.7523 C146.7937,19.3033 148.0617,18.2893 150.3077,18.2893 C151.3937,18.2893 151.9717,18.5073 152.1907,18.6153 L152.1907,21.6583 C151.6467,21.4403 150.8497,21.2233 149.8727,21.2233 C148.0977,21.2233 147.0467,21.9463 146.5407,22.7083 L146.5407,34.5503 L143.0627,34.5503 L143.0627,18.6513 Z",
    id: "path-13"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M158.7165,10.5746 L162.1945,10.5746 L162.1945,20.2086 C162.7365,19.4846 164.1495,18.2896 166.5395,18.2896 C169.9435,18.2896 173.2755,20.5346 173.2755,26.5466 C173.2755,32.5956 169.9815,34.9136 166.5395,34.9136 C163.9325,34.9136 162.4115,33.6466 161.7225,32.5956 L161.7225,34.5506 L158.7165,34.5506 L158.7165,10.5746 Z M162.1945,30.6386 C162.9895,31.4716 164.1855,31.9796 165.5985,31.9796 C168.3515,31.9796 169.7645,30.0246 169.7645,26.5826 C169.7645,23.1426 168.3515,21.2236 165.5985,21.2236 C164.1855,21.2236 162.9895,21.7296 162.1945,22.5626 L162.1945,30.6386 Z",
    id: "path-15"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M175.4548,18.6513 L178.9328,18.6513 L178.9328,27.7423 C178.9328,30.4593 179.5108,31.9063 181.9738,31.9063 C183.7498,31.9063 184.8358,31.1463 185.4878,30.4953 L185.4878,18.6513 L188.9638,18.6513 L188.9638,34.5503 L185.9938,34.5503 L185.9938,32.4853 C185.1248,33.7893 183.5308,34.9133 180.8158,34.9133 C178.2068,34.9133 175.4548,33.8273 175.4548,28.4303 L175.4548,18.6513 Z",
    id: "path-17"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M194.6941,29.4086 C194.8021,31.2186 196.2501,32.4136 198.4591,32.4136 C200.2341,32.4136 201.5021,31.6526 201.5021,30.2416 C201.5021,28.5016 199.6191,28.2846 196.7211,27.4516 C194.4391,26.7996 191.9391,25.8946 191.9391,22.8526 C191.9391,19.5196 195.0191,18.2896 198.0621,18.2896 C201.5741,18.2896 204.1831,19.9186 204.4001,23.2866 L200.9941,23.2866 C200.9221,21.8026 199.8001,20.7516 197.9521,20.7516 C196.5031,20.7516 195.3461,21.4036 195.3461,22.6356 C195.3461,24.3016 197.4081,24.4816 200.2341,25.2786 C202.5521,25.9306 204.9421,26.9446 204.9421,30.0246 C204.9421,33.6816 201.6091,34.9136 198.3871,34.9136 C194.4771,34.9136 191.5791,33.1016 191.2881,29.4086 L194.6941,29.4086 Z",
    id: "path-19"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M207.157,14.0512 L207.157,10.5742 L211.069,10.5742 L211.069,14.0512 L207.157,14.0512 Z M207.374,34.5512 L207.374,18.6522 L210.852,18.6522 L210.852,34.5512 L207.374,34.5512 Z",
    id: "path-21"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M214.2224,18.6513 L217.1924,18.6513 L217.1924,20.7163 C218.0614,19.3753 219.6914,18.2893 222.4434,18.2893 C225.0884,18.2893 227.8764,19.3753 227.8764,24.7363 L227.8764,34.5503 L224.4014,34.5503 L224.4014,25.4233 C224.4014,22.7443 223.7854,21.2953 221.2504,21.2953 C219.4744,21.2953 218.3164,22.0193 217.7004,22.7083 L217.7004,34.5503 L214.2224,34.5503 L214.2224,18.6513 Z",
    id: "path-23"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M244.6526,29.2992 C244.0366,33.7172 240.2696,34.9132 237.4816,34.9132 C233.6796,34.9132 230.0576,32.7772 230.0576,26.5822 C230.0576,20.3182 233.8966,18.2902 237.3716,18.2902 C240.7786,18.2902 244.7246,20.1362 244.7246,26.5472 L244.7246,27.0912 L233.4976,27.0912 C233.5696,30.4592 234.9466,32.1972 237.5906,32.1972 C239.6896,32.1972 240.9576,31.1112 241.2846,29.2992 L244.6526,29.2992 Z M241.2486,25.0262 C241.0316,22.3452 239.6546,20.9332 237.4096,20.9332 C235.1286,20.9332 233.7866,22.3452 233.5336,25.0262 L241.2486,25.0262 Z",
    id: "path-25"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M249.4406,29.4086 C249.5486,31.2186 250.9976,32.4136 253.2066,32.4136 C254.9816,32.4136 256.2496,31.6526 256.2496,30.2416 C256.2496,28.5016 254.3656,28.2846 251.4676,27.4516 C249.1856,26.7996 246.6866,25.8946 246.6866,22.8526 C246.6866,19.5196 249.7656,18.2896 252.8086,18.2896 C256.3206,18.2896 258.9296,19.9186 259.1466,23.2866 L255.7406,23.2866 C255.6696,21.8026 254.5466,20.7516 252.6986,20.7516 C251.2516,20.7516 250.0926,21.4036 250.0926,22.6356 C250.0926,24.3016 252.1546,24.4816 254.9816,25.2786 C257.2996,25.9306 259.6886,26.9446 259.6886,30.0246 C259.6886,33.6816 256.3566,34.9136 253.1336,34.9136 C249.2236,34.9136 246.3256,33.1016 246.0346,29.4086 L249.4406,29.4086 Z",
    id: "path-27"
  }), (0, _themeUi.jsx)("path", {
    /* eslint-disable-next-line max-len */
    d: "M274.574,29.9558423 L274.574,30.0937849 C274.532203,33.6971544 271.22199,34.9136 268.0194,34.9136 C264.1094,34.9136 261.2114,33.1016 260.9204,29.4086 L264.3264,29.4086 C264.4344,31.2186 265.8844,32.4136 268.0924,32.4136 C269.8674,32.4136 271.1354,31.6526 271.1354,30.2416 C271.1354,28.5016 269.2514,28.2846 266.3534,27.4516 C264.0714,26.7996 261.5724,25.8946 261.5724,22.8526 C261.5724,19.5196 264.6514,18.2896 267.6944,18.2896 C271.2064,18.2896 273.8154,19.9186 274.0324,23.2866 L270.6264,23.2866 C270.5554,21.8026 269.4324,20.7516 267.5854,20.7516 C266.1374,20.7516 264.9784,21.4036 264.9784,22.6356 C264.9784,24.3016 267.0404,24.4816 269.8674,25.2786 C272.167072,25.9257239 274.538656,26.9294533 274.574,29.9558423 Z",
    id: "path-29"
  })), (0, _themeUi.jsx)("polygon", {
    id: "path-31"
    /* eslint-disable-next-line max-len */
    ,
    points: "34.5108483 43.8862 29.7288483 43.8862 39.1037 18.5976 43.8867 18.5976 34.5108483 43.8862"
  }), (0, _themeUi.jsx)("polygon", {
    id: "path-33",
    points: "17.5789259 0.0002 4.782 34.54 0 34.54 12.7969259 0.0002"
  }), (0, _themeUi.jsx)("polygon", {
    id: "path-35",
    points: "28.6506259 0.0002 15.8547 34.54 11.0717 34.54 23.8686259 0.0002"
  }), (0, _themeUi.jsx)("polygon", {
    id: "path-37",
    points: "26.8913 34.54 22.1093 34.54 28.0123 18.597 32.7943 18.597"
  })), (0, _themeUi.jsx)("g", {
    id: "logo-normal",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, (0, _themeUi.jsx)("mask", {
    id: "mask-2",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-1"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-133",
    fill: "currentColor",
    xlinkHref: "#path-1"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-4",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-3"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-136",
    fill: "currentColor",
    xlinkHref: "#path-3"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-6",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-5"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-139",
    fill: "currentColor",
    xlinkHref: "#path-5"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-8",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-7"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-142",
    fill: "currentColor",
    xlinkHref: "#path-7"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-10",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-9"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-145",
    fill: "currentColor",
    xlinkHref: "#path-9"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-12",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-11"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-148",
    fill: "currentColor",
    xlinkHref: "#path-11"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-14",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-13"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-151",
    fill: "currentColor",
    xlinkHref: "#path-13"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-16",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-15"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-154",
    fill: "currentColor",
    xlinkHref: "#path-15"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-18",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-17"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-157",
    fill: "currentColor",
    xlinkHref: "#path-17"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-20",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-19"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-160",
    fill: "currentColor",
    xlinkHref: "#path-19"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-22",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-21"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-163",
    fill: "currentColor",
    xlinkHref: "#path-21"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-24",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-23"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-166",
    fill: "currentColor",
    xlinkHref: "#path-23"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-26",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-25"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-169",
    fill: "currentColor",
    xlinkHref: "#path-25"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-28",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-27"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-172",
    fill: "currentColor",
    xlinkHref: "#path-27"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-30",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-29"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-175",
    fill: "currentColor",
    xlinkHref: "#path-29"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-32",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-31"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-178",
    fill: "currentColor",
    xlinkHref: "#path-31"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-34",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-33"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-181",
    fill: "currentColor",
    xlinkHref: "#path-33"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-36",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-35"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-184",
    fill: "currentColor",
    xlinkHref: "#path-35"
  }), (0, _themeUi.jsx)("mask", {
    id: "mask-38",
    fill: "white"
  }, (0, _themeUi.jsx)("use", {
    xlinkHref: "#path-37"
  })), (0, _themeUi.jsx)("use", {
    id: "Clip-187",
    fill: "currentColor",
    xlinkHref: "#path-37"
  })));
};

Logo.propTypes = {
  icon: _propTypes["default"].bool,
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)])
};
Logo.defaultProps = {
  icon: false,
  width: 275,
  fill: "black"
};
var _default = Logo;
exports["default"] = _default;